// extracted by mini-css-extract-plugin
export default {"modalContentSmall":"ReportLostDamagedPalletsModal_modalContentSmall__Xorhf","modalContentLarge":"ReportLostDamagedPalletsModal_modalContentLarge__WK0FH"};